import { AppEnvironment } from './environment.types';
import { buildStagingEnvironment } from './environment.staging';

export const environment: AppEnvironment = buildStagingEnvironment('test');
